module.exports = __webpack_public_path__ + "static/Murphy_patient_intake_form-043632a9211eac04b4c278ce41ba0377.pdf";